import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import React from 'react'
import { COLORS } from 'theme'

import {
  GreyText,
  SecondaryHeading,
  SecondGreyText,
  StyledP,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import DividerIcon from '../../../../../../../../../components/icons/DividerIcon'
import WorkIcon from '../../../../../../../../../components/icons/WorkIcon'
import { FlexWrap } from '../../../../../../../../../components/UIComponents/FormStyles'
import { SubtitleSmall } from '../../../../../../../../../components/UIComponents/PreviewScreen/style'
import { TextContainer } from '../../../../../../../../JobPreview/style'

const InfoSection = ({
  name,
  company,
  work,
  skills,
  duration,
  resume,
  functionName,
  role,
  industry,
}) => {
  return (
    <SubFLex column gap="25px">
      <SubFLex gap="12px">
        <div>
          <Avatar
            background="none"
            src={''}
            size={48}
            icon={resume ? <WorkIcon /> : <ApartmentIcon />}
            boxShadow={true}
            padding="5px"
          />
        </div>
        <SubFLex column>
          <SecondaryHeading>{name}</SecondaryHeading>
          <SecondGreyText>{company}</SecondGreyText>

          {resume ? (
            <>
              <GreyText color={COLORS.GREY_T_60}>{duration}</GreyText>
              <SubFLex
                centerVertically
                gap="5px"
                marginBottom="5px"
                flexWrap="wrap"
              >
                {skills?.map((item, index) => (
                  <CustomTag
                    key={index + item?.name}
                    message={item?.name}
                    bordered={true}
                    border={COLORS.GREY_T_80}
                  />
                ))}
              </SubFLex>
            </>
          ) : (
            <>
              <StyledP
                webkitBox={true}
                dangerouslySetInnerHTML={{
                  __html: work,
                }}
              />
              <SubFLex
                centerVertically
                gap="5px"
                marginBottom="15px"
                flexWrap="wrap"
              >
                <SecondGreyText marginBottom="0">Skills -</SecondGreyText>
                {skills?.map((item, index) => (
                  <CustomTag
                    key={index + item?.name}
                    message={item?.name}
                    bordered={true}
                    border={COLORS.GREY_T_80}
                  />
                ))}
              </SubFLex>

              <GreyText color={COLORS.GREY_T_60}>{duration}</GreyText>
            </>
          )}
          {resume && (
            <FlexWrap gap="10px">
              <TextContainer>
                {functionName && (
                  <>
                    <SubFLex column>
                      <SecondGreyText>Function</SecondGreyText>
                      <SecondaryHeading>{functionName}</SecondaryHeading>
                    </SubFLex>
                    <SubtitleSmall>
                      <DividerIcon />
                    </SubtitleSmall>
                  </>
                )}
              </TextContainer>
              <TextContainer>
                {role && (
                  <>
                    <SubFLex column>
                      <SecondGreyText>Role</SecondGreyText>
                      <SecondaryHeading>{role}</SecondaryHeading>
                    </SubFLex>
                    <SubtitleSmall>
                      <DividerIcon />
                    </SubtitleSmall>
                  </>
                )}
              </TextContainer>
              <TextContainer>
                {industry && (
                  <SubFLex column>
                    <SecondGreyText>Industry</SecondGreyText>
                    <SecondaryHeading>{industry}</SecondaryHeading>
                  </SubFLex>
                )}
              </TextContainer>
            </FlexWrap>
          )}
          {resume && (
            <>
              {work && (
                <StyledP
                  dangerouslySetInnerHTML={{
                    __html: work,
                  }}
                />
              )}
            </>
          )}
        </SubFLex>
      </SubFLex>
    </SubFLex>
  )
}

export default InfoSection
